/**
 * Rosada Link Router
 * Leitet alle Shopify-Theme-internen Links auf die Vercel-Brand-Site um,
 * lässt Shop-Funktionalität (Produkte, Cart, Checkout) auf Shopify.
 */
(function () {
  'use strict';

  var VERCEL = (window.rosadaConfig && window.rosadaConfig.marketingSiteUrl) || 'https://rosada-web.vercel.app';
  if (VERCEL.charAt(VERCEL.length - 1) === '/') VERCEL = VERCEL.slice(0, -1);

  /**
   * Whitelist: dürfen auf Shopify bleiben.
   * Alles andere mit "/" oder relative path wird auf Vercel umgeleitet.
   */
  function shouldKeepOnShopify(href) {
    if (!href) return true;
    if (href.startsWith('#')) return true;
    if (href.startsWith('mailto:')) return true;
    if (href.startsWith('tel:')) return true;
    if (href.startsWith('javascript:')) return true;

    // External URLs (not myshopify) — keep as is
    if (/^https?:\/\//i.test(href)) {
      return !href.includes('.myshopify.com') ||
             href.includes('/products/') ||
             href.includes('/cart') ||
             href.includes('/checkout') ||
             href.includes('/account') ||
             href.includes('/admin') ||
             href.includes('/apps');
    }

    // Internal Shopify routes that should stay
    if (href.startsWith('/products/')) return true;
    if (href.startsWith('/cart')) return true;
    if (href.startsWith('/checkout')) return true;
    if (href.startsWith('/account')) return true;
    if (href.startsWith('/admin')) return true;
    if (href.startsWith('/apps')) return true;
    if (href.startsWith('/policies')) return true; // Legal pages
    if (href.startsWith('/search')) return true;

    return false;
  }

  /**
   * Map Shopify route → Vercel URL
   */
  function mapToVercel(href) {
    if (!href) return null;

    // Strip myshopify domain
    var path = href;
    if (/^https?:\/\//i.test(href)) {
      try {
        var u = new URL(href);
        if (!u.hostname.includes('.myshopify.com')) return null;
        path = u.pathname + u.search + u.hash;
      } catch (e) { return null; }
    }

    // Map routes
    if (path === '/' || path === '') return VERCEL + '/';
    if (path.startsWith('/collections')) return VERCEL + '/collection';
    if (path === '/pages/story' || path === '/pages/our-story') return VERCEL + '/story';
    if (path === '/pages/contact' || path === '/pages/contact-us') return VERCEL + '/contact';
    if (path === '/pages/collection' || path === '/pages/our-collection') return VERCEL + '/collection';
    if (path.startsWith('/pages/')) {
      var slug = path.replace('/pages/', '').split('?')[0].split('#')[0];
      // Known Vercel pages
      if (['story', 'contact', 'collection'].indexOf(slug) !== -1) {
        return VERCEL + '/' + slug;
      }
      return VERCEL + '/';
    }
    if (path.startsWith('/blogs')) return VERCEL + '/';

    return null;
  }

  function rewriteLinks() {
    document.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (shouldKeepOnShopify(href)) return;
      var newHref = mapToVercel(href);
      if (newHref && newHref !== href) {
        a.setAttribute('href', newHref);
        a.setAttribute('data-rerouted', 'true');
        // Open in same tab unless explicitly set
        if (!a.hasAttribute('target')) a.setAttribute('target', '_self');
      }
    });
  }

  /* Click-time fallback: handle any links added dynamically */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (a.getAttribute('data-rerouted') === 'true') return;
    if (shouldKeepOnShopify(href)) return;
    var newHref = mapToVercel(href);
    if (newHref) {
      e.preventDefault();
      window.location.href = newHref;
    }
  });

  /* Desktop-Rueckweg zur Marketing-Site: ein stiller Link links im Header.
     (Mobile hat die eigene Bar mit Burger-Menue.) */
  function addBackLink() {
    var row = document.querySelector('.header__row--top');
    if (!row || row.querySelector('.rosada-back-link')) return;
    var a = document.createElement('a');
    a.className = 'rosada-back-link';
    a.href = VERCEL + '/';
    a.textContent = '\u2190 rosada.ch';
    row.appendChild(a);
  }

  /* Initial rewrite */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteLinks(); addBackLink(); });
  } else {
    rewriteLinks();
    addBackLink();
  }

  /* Re-run after a tick — for late-rendered theme blocks */
  setTimeout(rewriteLinks, 200);
  setTimeout(rewriteLinks, 1000);

  /* Observe for dynamically added links (theme menu drawers etc.) */
  if (window.MutationObserver) {
    var obs = new MutationObserver(function () { rewriteLinks(); });
    if (document.body) {
      obs.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        obs.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();
